<template>
    <v-dialog width="900" v-model="showAssetCheckListView">
        <v-card>
            <v-card-title class="secondary white--text">
                <span>  checkList Items </span>

                <v-spacer></v-spacer>

                <v-btn icon @click="showAssetCheckListView = false">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>


            <AgGridVue style="width: 100%; height: calc(100vh - 240px)" :class="$vuetify.theme.dark ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'
                " id="myGrid" :columnDefs="headers" :context="context" @grid-ready="onGridReady"
                :defaultColDef="defaultColDef" :grid-options="gridOptions" :suppressDragLeaveHidesColumns="true"
                :rowData="checkListItems"></AgGridVue>
            <v-divider></v-divider>

        </v-card>
    </v-dialog>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
    components: {
        AgGridVue
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        checkListItems: {
            type: Array,
            default: () => []
        }



    },
    watch: {
        value(val) {
            if (val) {

            } else {
            }
        },
    },
    computed: {
        context() {
            return { parentComponent: this };
        },
        showAssetCheckListView: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {
            isValid: true,
            headers: [
                {
                    headerName: "Name",
                    field: "name",
                    tooltipField: "name",
                },
                {
                    headerName: "Is Mandatory",
                    field: "is_mandatory",
                    width: 60,
                    cellRenderer: (params) => {
                        return params.value
                            ? '<i class="mdi mdi-check" style="color: green;"></i>'
                            : '<i class="mdi mdi-close" style="color: red;"></i>';
                    },
                    cellStyle: { textAlign: "center" }
                },
                {
                    headerName: "Is Checked",
                    field: "is_checked",
                    width: 60,
                    cellRenderer: (params) => {
                        return params.value
                            ? '<i class="mdi mdi-check" style="color: green;"></i>'
                            : '<i class="mdi mdi-close" style="color: red;"></i>';
                    },
                    cellStyle: { textAlign: "center" }
                },

                {
                    headerName: "Remarks",
                    field: "remarks",
                    width: 60,
                },

            ],

            isTextInput: false,
            gridApi: null,
            gridColumnApi: null,
            defaultColDef: {
                resizable: true,
            },
            gridOptions: {
                onGridSizeChanged: () => {
                    this.gridOptions.api.sizeColumnsToFit();
                },
                suppressRowClickSelection: true,
                suppressDragLeaveHidesColumns: true,
                enableCellTextSelection: true,
                tooltipShowDelay: 0,
                rowHeight: 35,
            },

        };
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
        },

    },
};
</script>
